export default {
  beneficios: [],
  beneficio: {},
};
